'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { ImageIcon } from 'lucide-react'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { getResizedPictureUrl, tOptional } from '@/lib/utils'
import { FileType } from '@/types/file'

type PropsType = {
  picture?: FileType
  title?: string
}

const ContentDetailPicture = ({ picture, title }: PropsType) => {
  const t = useTranslations()

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ImageIcon className="h-5 w-5" />
          {title ? tOptional(t, title) : tOptional(t, 'picture')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {picture ? (
          <div className="xs:grid-cols-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-8">
            <PhotoProvider maskOpacity={0.5}>
              <div className="bg-checkerboard relative w-32 overflow-hidden rounded-md border">
                <PhotoView src={getResizedPictureUrl(picture.path, 800, 600)}>
                  <Image
                    src={getResizedPictureUrl(picture.path, 400, 300)}
                    alt={picture.name}
                    width={240}
                    height={240}
                    className="max-h-100 w-auto cursor-pointer rounded-md border object-contain hover:border-gray-500"
                  />
                </PhotoView>
              </div>
            </PhotoProvider>
          </div>
        ) : (
          <p className="text-muted-foreground">{t('no_picture')}</p>
        )}
      </CardContent>
    </Card>
  )
}

export default ContentDetailPicture
